import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { AuthenticationService } from "../../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IResidualAbsenceForm } from "app/auth/models/absences";

@Component({
  selector: "app-residual-absences-edit",
  templateUrl: "./residual-absences-edit.component.html",
  styleUrls: ["./residual-absences-edit.component.scss"],
})
export class ResidualAbsencesEditComponent implements OnInit {
  public contentHeader: IContentHeader;
  public xlsx_file_content: { complete_name: number; fiscal_code: string; type: string; quantity: string | number }[];
  public columnKey: Array<string> = [];
  public errorFiscalCode: boolean = false;
  public errorHolidays: boolean = false;
  public errorPermission: boolean = false;
  public fiscal_code_to_check: string;
  public fileName: string = null;

  constructor(
    public _absenceService: AbsencesService,
    private _router: Router,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
  ) {}

  async ngOnInit() {
    this.columnKey = this._absenceService.residual_absences_keys.filter((item) => item.length > 3);
    this.contentHeader = {
      headerTitle: "TITLES.EDIT_RESIDUAL_ABSENCES",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.LIST_RESIDUAL_ABSENCES",
            isLink: true,
            link: "/dashboard/list-residual-absences",
          },
          {
            name: "TITLES.EDIT_RESIDUAL_ABSENCES",
            isLink: false,
          },
        ],
      },
    };
  }

  async handlerChangeFileInput($event) {
    this.fileName = $event.target.files[0].name;
    if ($event.target.files && $event.target.files[0]) {
      this._utilService.parseXLSX(
        $event.target.files[0],
        this._absenceService.residual_absences_keys,
        {
          raw: true,
          defval: 0,
          header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "AA", "AB", "AC"],
        },
        (data) => {
          /*Oggetto che al suo interno avrà le chiavi fatte da codici fiscali e al suo interno conteremo per ogni
                    codice fiscale quanti codici fiscali ci sono, e quanti tipi di ferie
                    andrà in errore se i codici fiscali sono diversi da numero 2, e per tipo di assenza diverso da 1*/
          let countDuplicate = {};
          //Array contente tutte le chiavi da eliminare dall'oggetto data(tutte le row prensenti nel exel che carichiamo
          let keysToDelete = this._absenceService.residual_absences_keys.filter((key) => key.length < 3);
          this.xlsx_file_content = data.slice(1).map((item) => {
            //Slice(1) serve per togliere il primo oggetto il quale è composto dalle chiavi dell'excel importato
            keysToDelete.map((keyDelete) => {
              delete item[keyDelete];
            });
            countDuplicate[item.fiscal_code] = {
              //Inizializziamo soltanto le variabili a null per poterle riscriverle dopo
              countFiscalCode: null,
              countTypeHolidays: null,
              countTypePermissions: null,
            };
            return item;
          });

          this.xlsx_file_content.map((fileContent) => {
            //Itero l'array ed effettuiamo il controllo sui duplicati
            if (fileContent.type === "Ferie") {
              countDuplicate[fileContent.fiscal_code].countTypeHolidays += 1;
            } else {
              countDuplicate[fileContent.fiscal_code].countTypePermissions += 1;
            }
            countDuplicate[fileContent.fiscal_code].countFiscalCode += 1;
          });
          //Itero le chiavi dell'oggetto countDuplicate(le quali sono codici fiscali)
          Object.keys(countDuplicate).map((key) => {
            if (!this.errorFiscalCode && !this.errorPermission && !this.errorHolidays) {
              this.errorFiscalCode = countDuplicate[key].countFiscalCode !== 2;
              this.errorPermission = countDuplicate[key].countTypePermissions !== 1;
              this.errorHolidays = countDuplicate[key].countTypeHolidays !== 1;
              if (this.errorFiscalCode || this.errorPermission || this.errorHolidays) {
                this.fiscal_code_to_check = key;
                /*Se va in errore la variabile fiscal_code_to_check mostrerà all'utente quale codice fiscale
                                controllare*/
              }
            }
          });
        },
      );
    }
  }

  async save() {
    if (!this._authenticationService.hasCapability("update_users_absences")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    let data: IResidualAbsenceForm | {} = {};
    //Per ogni codice fiscale creo una chiave che al suo interno avrà permessi e ferie
    this.xlsx_file_content.map((fileContent: { complete_name: number; fiscal_code: string; type: string; quantity: string | number }) => {
      data[fileContent.fiscal_code] = {
        permissions: null,
        holidays: null,
      };
    });
    this.xlsx_file_content.map((fileContent: { complete_name: number; fiscal_code: string; type: string; quantity: string }) => {
      if (fileContent.type === "Ferie") {
        data[fileContent.fiscal_code].holidays = parseFloat(fileContent.quantity);
      } else {
        data[fileContent.fiscal_code].permissions = parseFloat(fileContent.quantity);
      }
    });
    return this._absenceService
      .updateResidualAbsences(data)
      .then(async (result) => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_RESIDUAL_ABSENCES" });
        await this._router.navigate(["/dashboard/list-residual-absences"], { state: { result: result } });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_RESIDUAL_ABSENCES" });
      });
  }
}
